let acceptedValueByElement = new WeakMap();
let confirmedAutofillBatch = null;

export function startAutocompleteBatch(formId, sourceElement, at = Date.now()) {
  if (!formId || !sourceElement) return;

  confirmedAutofillBatch = { formId, sourceElement, at };
}

export function isWithinAutocompleteBatch(formId, targetElement, at, windowMs) {
  const batch = confirmedAutofillBatch;
  if (!batch || batch.formId !== formId || batch.sourceElement === targetElement) return false;

  const elapsedMs = at - batch.at;
  return elapsedMs >= 0 && elapsedMs <= windowMs;
}

export function rememberAutocompleteAcceptedValue(element) {
  if (!element || typeof element.value !== 'string') return;
  acceptedValueByElement.set(element, element.value);
}

export function hasAutocompleteAcceptedValue(element) {
  return !!element && acceptedValueByElement.has(element);
}

export function recordAutocompleteAcceptance(fld, element) {
  if (!fld?.runtime || !fld.autocomplete || typeof element?.value !== 'string' || element.value.length === 0)
    return false;
  if (fld.runtime.autocompleteAcceptedRecorded || !fld.autocomplete.detected) return false;

  // Native browser suggestion UI is outside the page DOM: a confirmed
  // acceptance is the first trustworthy autocomplete signal available to us.
  fld.runtime.autocompleteAcceptedRecorded = true;
  rememberAutocompleteAcceptedValue(element);
  fld.autocomplete_accepted_count += 1;
  return true;
}

export function discardAutocompleteAcceptedValue(element) {
  if (!element) return;
  acceptedValueByElement.delete(element);
}

export function finalizeAutocompleteEdit(fld, element) {
  if (!element || !acceptedValueByElement.has(element)) return false;

  const acceptedValue = acceptedValueByElement.get(element);
  const finalValue = typeof element.value === 'string' ? element.value : null;
  // Safari can blur a sibling field immediately after Contact AutoFill, before
  // the person has had a chance to edit it. Retain the baseline through that
  // unchanged blur; it is cleared by the first actual edit or at session end.
  if (!fld.autocomplete || finalValue === null || finalValue === acceptedValue) return false;

  acceptedValueByElement.delete(element);
  fld.autocomplete.edits_after += 1;
  return true;
}

export function clearAutocompleteAcceptedValues() {
  acceptedValueByElement = new WeakMap();
  confirmedAutofillBatch = null;
}
